var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u-clear" }, [
    _vm._m(0),
    _vm._v(" "),
    _vm.canvas
      ? _c(
          "div",
          { staticClass: "u-fl field small" },
          [
            _c("label", { staticClass: "label" }, [_vm._v("Width")]),
            _vm._v(" "),
            _c("ui-number", {
              attrs: { value: _vm.canvas.width },
              on: {
                change: function($event) {
                  return _vm.zoom("width", $event)
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.canvas
      ? _c(
          "div",
          { staticClass: "u-fl field small" },
          [
            _c("label", { staticClass: "label" }, [_vm._v("Height")]),
            _vm._v(" "),
            _c("ui-number", {
              attrs: { value: _vm.canvas.height },
              on: {
                change: function($event) {
                  return _vm.zoom("height", $event)
                }
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "u-fl field large" },
      [
        _c("label", { staticClass: "label" }, [_vm._v("Barcode type")]),
        _vm._v(" "),
        _c("ui-select", {
          attrs: { value: _vm.active.barcodeType, options: _vm.barcodes },
          on: {
            change: function($event) {
              return _vm.generate($event, _vm.active.barText)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "u-fl field large" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Bar text")]),
      _vm._v(" "),
      _c("input", {
        staticClass: "f-input",
        attrs: { type: "text" },
        domProps: { value: _vm.active.barText },
        on: {
          change: function($event) {
            return _vm.generate(_vm.active.barcodeType, $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "u-fl field large" }, [
      _c(
        "a",
        { staticClass: "u-fr f-button primary", on: { click: _vm.print } },
        [_vm._v("Print")]
      ),
      _vm._v(" "),
      _c(
        "a",
        { staticClass: "u-fr f-button default", on: { click: _vm.reset } },
        [_vm._v("Reset")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [_c("p", [_vm._v("Print")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }